<div id="{{theme}}-app" class="feedback-dialog">
    <div mat-dialog-title>
        <div class="row">
            <div class="">
                <h3 class="feedback_title" style="margin-left: 20px;">{{ "Label.Have_Feedback" | translate}}</h3>
            </div>
            <div class="float-right ml-auto">
                <span class="fa fa-close action-icons" (click)="close()"></span>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <form [formGroup]="feedbackForm" (ngSubmit)="feedbackForm.valid && onSave(feedbackForm.value)" novalidate>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12 mt-2">
                        <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                            <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                                <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                                {{ alert.msg }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.model" | translate}} :</mat-label>
                            <input disabled matInput placeholder="Model" required formControlName="model">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.year" | translate}} :</mat-label>
                            <input disabled matInput placeholder="Year" required formControlName="year">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.feature" | translate}} :</mat-label>
                            <input matInput disabled placeholder="Feature" required formControlName="feature">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.feedback" | translate}} :</mat-label>
                            <textarea matInput required placeholder="Describe issue/share feedback (5000 characters limit)*" formControlName="feedback"></textarea>
                            <mat-error *ngIf="hasError('feedback', 'required')">Feedback is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.feedbacktype" | translate}} : </mat-label>
                            <mat-select formControlName="feedbackType" required>
                                <mat-option value="Technical issue">Technical issue</mat-option>
                                <mat-option value="Missing/Incorrect information">Missing/Incorrect information</mat-option>
                                <mat-option value="Enhancements/Suggestion">Enhancements/Suggestion</mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('feedbackType', 'required')">Type is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.firstName" | translate}} :</mat-label>
                            <input matInput placeholder="firstName" required formControlName="firstName">
                            <mat-error *ngIf="hasError('firstName', 'required')">FirstName is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.lastName" | translate}} :</mat-label>
                            <input matInput placeholder="lastName" formControlName="lastName" required>
                            <mat-error *ngIf="hasError('lastName', 'required')">LastName is required</mat-error>

                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.phoneNumber" | translate}} :</mat-label>
                            <input matInput placeholder="Phone Number" formControlName="phoneNumber" name="phoneNumber">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.email" | translate}} :</mat-label>
                            <input matInput placeholder="email" formControlName="email" required name="email">
                            <mat-error *ngIf="hasError('email', 'required')">Email is required</mat-error>
                            <mat-error *ngIf="hasError('email', 'email')">Please enter valid Email Id</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-checkbox class="example-margin" [checked]="feedbackDetails.feedback.includeScreenshot" [(ngModel)]="feedbackDetails.feedback.includeScreenshot"
                            (change)="includeScreenshot($event.checked)" [ngModelOptions]="{standalone: true}">
                            {{"Label.Include_Screenshot" | translate}}
                        </mat-checkbox>
                    </div>
                </div>
                <div class="row" *ngIf="feedbackDetails.feedback.includeScreenshot">
                    <div class="col-12" id="screenshotInfo" [ngStyle]="{'height' : feedbackDetails.feedback.includeScreenshot ? '210px' : '0px'}">
                        <img class="" [alt]="" id="screenshotInfo1" [src]="feedbackDetails.feedback.screenshotURL" width="100%" height="100%">
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions feedback-actions">
        <span>
            <button mat-raised-button color="primary" class="btn btn-default" (click)="onSave(feedbackForm.value)">{{"Button.submit" | translate}}</button>

        </span>
        <span class="ml-2">
            <button class="btn btn-secondary" (click)="onCancel()">{{"Button.cancel" | translate}}</button>
        </span>
    </div>
</div>